export const REDIRECTION_STATUS_CODE = {
  NO_REDIRECT: 200,
  SELF_REDIRECT: 301,
  TEMP_REDIRECT: 307,
  TARGET_REDIRECT: 308,
  NOT_FOUND: 404,
} as const;

export type RedirectionStatusCode =
  (typeof REDIRECTION_STATUS_CODE)[keyof typeof REDIRECTION_STATUS_CODE];

// Temporary business decision to hide reviews page for a specific company
export const HIDE_REVIEWS_COMPANY_IDS = ['171714318692361'];
